import type { MergeRowDto } from '../api/mergeResolution.types';

export function detailToClipboardText(
  row: MergeRowDto,
  dimensionHeaders: string[],
  label: (dateId: string | null) => string,
  periodKeys?: (string | null)[]
): string {
  // Line 1: dimension headers
  const dimensionLine = row.Dimensions.map(
    (value, i) => `${dimensionHeaders[i] ?? `Dimension ${i + 1}`}=${value}`
  ).join(' · ');

  // Line 2: TSV header
  const headerLine = 'Period\tBase\tTheirs\tMine\tVariance\tVariance %';

  // Data lines: one per period
  const periods = periodKeys
    ? periodKeys.flatMap((k) => row.Periods.filter((p) => p.DateID === k))
    : row.Periods;
  const dataLines = periods.map((period) =>
    [
      label(period.DateID),
      period.Base ?? '',
      period.Theirs ?? '',
      period.Mine ?? '',
      period.Raw_Difference ?? '',
      period.Pct_Difference ?? '',
    ].join('\t')
  );

  return [dimensionLine, headerLine, ...dataLines].join('\n');
}
